import { isEqual } from "date-fns";
import { isArray } from "lodash";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";

/**
 * Function searching in collection of excluded dates for particular date.
 * Used mainly on datepickers.
 * @param {Date} day - day to check, current day or date from calendar.
 * @param {array} excludedDays - collection of excluded days from API.
 * @returns {IExcludedDay} - if searched date is excluded, returns it's data.
 */
export default (
  day: Date,
  excludedDays: IExcludedDay[]
): IExcludedDay | undefined => {
  if (!isArray(excludedDays)) return undefined;

  return excludedDays.find((currentDay) =>
    isEqual(day, new Date(currentDay.date).setHours(0, 0, 0))
  );
};
